
import landingBackgroundImage from '../assets/img/banner/ALFIN-CONTACTO-BANNER.jpg';

export const CONSTANTES = {
  FECHA_CAMPANIA: "24/07/2026",
  LANDING_BACKGROUND_IMAGE: landingBackgroundImage
};
